module.exports = __webpack_public_path__ + "img/level.15d41db2.png";